<template>
    <div class="my-chooser">
        <div class="row" v-for="entity_type_data in input_type__text">
            <div class="col-lg-8 ">
                <div class="md-form mt-1 mb-0">
                    <input :type="entity_type_data.type"
                           v-bind:name="'entity_type_data[entity_type_fields][individuals]['+entity_type_data.index+']'"
                           v-bind:id="entity_type_data.index" class="form-control"

                           :required="entity_type_data.required">
                    <label v-bind:for="entity_type_data.index">{{entity_type_data.title}}</label>
                </div>
            </div>
            <div class="col-lg-4">
                <p class="align-text-bottom">
                    <small class="text-muted" v-html="entity_type_data.description.long"></small>
                </p>
            </div>
        </div>
        <div class="row" v-for="entity_type_data in input_type__date">

            <div class="col-lg-8 ">
                <div class="md-form mt-1 mb-0">
                    <input type="text" class="form-control datepicker"
                           v-model="entity_type_data.index"
                           v-bind:id="entity_type_data.index"
                           v-bind:name="'entity_type_data[entity_type_fields][individuals]['+entity_type_data.index+']'"
                           :required="entity_type_data.required"

                           v-bind:disabled="entity_type_data.group == '_parent'?false:
                           !readParentRecordForEnable(entity_type_data)"
                    >
                    <!--if parent !disabled-->

                    <label v-bind:for="entity_type_data.index">{{entity_type_data.title}}</label>
                </div>
            </div>
            <div class="col-lg-4">
                <p class="align-text-bottom">
                    <small class="text-muted" v-html="entity_type_data.description.long"></small>
                </p>
            </div>
        </div>
        <!--time selector-->
        <div class="row" v-for="entity_type_data in input_type__time">

            <div class="col-lg-8 ">
                <div class="md-form mt-1 mb-0">
                    <input type="text" class="form-control timepicker"
                           v-bind:id="entity_type_data.index"
                           v-bind:name="'entity_type_data[entity_type_fields][individuals]['+entity_type_data.index+']'"
                           :required="entity_type_data.required"
                           v-bind:disabled="entity_type_data.disabled">
                    <label v-bind:for="entity_type_data.index">{{entity_type_data.title}}</label>
                </div>
            </div>
            <div class="col-lg-4">
                <p class="align-text-bottom">
                    <small class="text-muted" v-html="entity_type_data.description.long"></small>
                </p>
            </div>
        </div>
        <!--checkbox-->
        <div class="row" v-for="entity_type_data in input_type__checkbox">

            <div class="col-lg-8 ">
                <div class="md-form mt-1 mb-lg-5 mb-md-3">
                    <input type="checkbox" class="form-control"
                           v-bind:id="entity_type_data.index"
                           v-bind:name="'entity_type_data[entity_type_fields][individuals]['+entity_type_data.index+']'"
                           :required="entity_type_data.required">
                    <label v-bind:for="entity_type_data.index">{{entity_type_data.title}}</label>
                </div>
            </div>
            <div class="col-lg-4">
                <p class="align-text-bottom">
                    <small class="text-muted" v-html="entity_type_data.description.long"></small>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import {urlFormat} from '../../urlFormat';

    let entity_type_data, pickadate_params = {};

    export default {

        lang: '',
        props: {
            content: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            lat: {
                type: Number,
                default: null
            },
            long: {
                type: Number,
                default: null
            },
        },
        mounted() {
            let self = this,
                selectControllerElm = $('#entity-type--select');

            self.selectFieldWatcher();
            self.name2Slug = self.initName2Slug();

            if (selectControllerElm.val() !== '') {
                self.triggerSelectedType(selectControllerElm);
            }
        },
        data: function () {
            return {
                pickadate_params: [],
                input_type__text: [],
                input_type__textarea: [],
                input_type__date: [],
                input_type__time: [],
                input_type__checkbox: [],
                name2Slug: {}
            }
        },
        created() {
        },
        methods: {
            initName2Slug() {
                let propsData = {
                        content: this.content.name_to_slug
                    },
                    props = ['input_name__name', 'input_name__id', 'input_name__value', 'input_slug__name', 'input_slug__id', 'input_slug__value'];

                //create the propsData

                let nameToSlug = Vue.extend({
                    props: props
                });

                return new nameToSlug({
                    el: '#name_to_slug--wrapper',
                    propsData: propsData
                })
            },
            initDateTimeGroup(groupName, data) {

                let dateTime = Vue.extend({
                        props: {
                            open_time:{
                                type:Object,
                                default:function(){
                                    return Object;
                                }
                            },
                            close_time:{
                                type:Object,
                                default:function(){
                                    return Object;
                                }
                            },
                        }
                    }),
                    propsData = this.createGroupVueData(groupName, data);

                propsData['name_to_slug'] = this.name2Slug;



               let dateTimeVue =  new dateTime({
                   parent: this,
                    el: '#date_time_sequencer--wrapper',
                    propsData: propsData
                });
            },
            initLocationGroup: function (groupName, data) {
                let location = Vue.extend({
                        props: [
                            'lat',
                            'long',
                            'postcode',
                            'geocode',
                            'name_to_slug'
                        ]
                    }),
                    propsData = this.createGroupVueData(groupName, data);

                propsData['name_to_slug'] = this.name2Slug;

                new location({
                    el: '#location--wrapper',
                    propsData: propsData
                });
            },
            /**
             * Compiles data for vue
             * */
            createGroupVueData: function (groupName, data) {
                let self = this,
                    propsData = {};

                $.each(data[groupName].items, function (prop, item) {
                    let value = null;
                    if (prop === 'lat') {
                        value = self.lat;
                    } else if (prop === 'long') {
                        value = self.long;
                    } else {
                        value = ('value' in item) ? item.value : null
                    }
                    propsData[prop] = {
                        id: urlFormat(`groups[${groupName}][items][${prop}]`, {
                            alphaChar: true
                        }),
                        el: `entity_type_data[entity_type_fields][groups][${groupName}][items][${prop}]`,
                        value: value
                    };
                });
                return propsData;
            },
            readParentRecordForEnable: function (data) {
                console.log('group', data.group, 'this.group', this[data.group], this);
                return false;
            },
            /**
             * Watch the select field change
             */
            selectFieldWatcher: function () {
                let self = this;

                self.lang = $('body').data('lang');
                $('#entity-type--select').change(function (e) {
                    console.log('entity-type--select changed')
                    self.triggerSelectedType($(this));
                });
            },

            /**
             * Triggers the groups loader by watching the select field. The options contain the parameters used to parse
             * to the group or individual
             * Options parameters contain a data-input-field attribute
             * */
            triggerSelectedType(elm) {
                let self = this;

                self.lang = $('body').data('lang');
                if (elm.val()) {
                    // get the entityTypes
                    let data = elm.children('option:selected').data('input-fields');

                    for (let key in data) {
                        if ('groups' in data) {
                            /**
                             * date_time group found so set the var to true and remove it from the data
                             */
                            if ('open_close_full' in data.groups) {
                                self.initDateTimeGroup('open_close_full', data.groups);

                                //delete the groups key
                                delete data.groups.open_close_full;
                            }
                            if ('location' in data.groups) {
                                self.initLocationGroup('location', data.groups);
//					            delete data.groups.location;
                            }
                        }
                    }
                    self.createTypeIndividuals(data);
                }
            },
            /**
             * Creates the individual type inputs for only individuals
             * @param inputData
             */
            createTypeIndividuals: function (inputData) {
                let self = this;
                $('#entity_types--wrapper').find('.row').remove();

                /**
                 * @param {{element_attributes,validation,group}} input jetbrains validation
                 */
                $.each(inputData, function (group, input) {
                    group = String(group);
//					console.log('group',group);
                    if (group !== 'groups') {
                        self.createInputType(group, input);
                    }
                });
//				self.initPickADateParams();

            },
            createInputType: function (group, item) {
                let self = this;
                $.each(item, function (index, input) {

                    let compile = {
                        index: index,
                        title: input.lang[self.lang].title,
                        description: input.lang[self.lang].description,
                        type: input.element_attributes.type,
                        required: input.element_attributes.required,
                        validation: (input.hasOwnProperty('validation') ? input.validation : null),
                        disabled: null,
                        group: group === 'groups' ? input : null
                    };
                    switch (compile.type) {
                        case 'date':
                            compile.type = 'text';
                            compile.render = 'date';
                            pickadate_params[compile.index] = self.initPickADate(compile);
                            break;

                        case 'time':
                            compile.type = 'text';
                            compile.render = 'time';
                            pickadate_params[compile.index] = self.initPickADate(compile);
                            break;

                        case 'checkbox':
                            self.input_type__checkbox.push(compile);
                            break;

                        default:
                            // is text
                            self.input_type__text.push(compile);
                            break;
                    }
                });

            },
            /**
             * Iterates through generated input data. Creates the required input field
             * @param inputData
             */

            renderDateTime: function (parent) {
                let self = this, _parent = parent;
                self.$nextTick(function () {
//					if (_parent.render === 'date') {
//						$('#' + _parent.index)
//							.attr('disabled', false)
//							.pickadate({
//								darktheme: true,
//								onSet: function (thingSet) {
//									let dateValue = this.get();
////										if (this.$node.data('opposite-datepicker')) {
////
////											endDateElm.pickadate({
////												darktheme: true,
////												min: this.get(),
////												onSet: function (thingSet) {
////
////												}
////											});
////											endDateElm.pickadate('picker').set('select', dateValue);
////											$('#end_time, #end_date').attr('disabled', false);
////										}
//								}
//							});
//					}
//					else {
//						$('#' + +_parent.index)
//                            .attr('disabled', false)
//                            .pickatime({
//							// 12 or 24 hour
//							twelvehour: true,
//							// Light or Dark theme
//							darktheme: false
//						});
//					}

                });
            },
            /**
             * Looks for the next child where the group was the previous parent
             * @param parent
             * @returns {*}
             */
            readNextChild: function (parent) {
                let self = this;
                for (let key in pickadate_params) {
                    let targetGroup = pickadate_params[key].group;

                    if (targetGroup === parent) {
                        let content = pickadate_params[key];

                        delete pickadate_params[key];
                        content.compile.disabled = 'disabled';
                        if (content.compile.render === 'time') {
                            self.input_type__time.push(content.compile);
                        } else {
                            self.input_type__date.push(content.compile);
                        }
                        this.readNextChild(key);

                    }

                }
            },
            initPickADateParams: function () {
                let self = this;
                //find the parent
                // element.group.name
                let parent, parentId;

                for (let key in pickadate_params) {
                    let targetGroup = pickadate_params[key].group;
                    if (targetGroup === '_parent') {
                        parent = pickadate_params[key];

                        parentId = parent.compile.index;
                        self.input_type__date.push(parent.compile);
                        delete pickadate_params[key];
                        self.renderDateTime(parent.compile);
                    }
                }
                self.readNextChild(parentId);

            },
//			readPickADateValidationParams: function (validationArray, keys) {
//				let options = {};
//
//				// iterate the array to get the key to search for
//				for (let i = 0; i < keys.length; i++) {
//					let result = this.findKeyLikeInArray(validationArray, keys[i]);
//					options = this.createOptions(options, result);
//				}
//				return options;
//			},
            findKeyLikeInArray: function (array, textToFind) {
                let index, value;

                for (index = 0; index < array.length; ++index) {
                    value = array[index];
                    if (value.substring(0, textToFind.length) === textToFind) {
                        // You've found it, the full text is in `value`.
                        // So you might grab it and break the loop, although
                        // really what you do having found it depends on
                        // what you need.
                        let resultArray = value.split(':'),
                            compile = {};

                        compile[resultArray[0]] = resultArray[1];
                        return compile;
                    }
                }
                return -1;
            },
            initPickADate: function (compile) {
//				console.log(compile, 'this.createValidations(compile.validation)', Object.keys(compile.validation));
                let validation = this.readPickADateValidationParams(Object.keys(compile.validation), ['before', 'after']);

                return {
                    id: compile.id,
                    validation: this.createOptions(validation, {}),
                    compile: compile,
                    group: compile.group
                };
            },
//			initPickATime: function (compile) {
//				let validation = this.readPickADateValidationParams(Object.keys(compile.validation), ['before', 'after']),
//					set = {
//						id: compile.id,
//						compile: this.createOptions(validation, {}),
//						group: compile.group
//					};
//
//				if (!compile.group) {
//					$('#' + compile.key).pickatime(this.createOptions({
//						// 12 or 24 hour
//						twelvehour: true,
//						// Light or Dark theme
//						darktheme: false
//					}, {}));
//				}
//				return set;
//
//			}
//			,
            createOptions: function (settings, options) {
                return $.extend(settings, options, {});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/EntityTypesCompiler.vue?595b0287